/**
 * @author Shivam Kapoor (shivamk2021@email.iimcal.ac.in)
 */

import app from "firebase/app";
import 'firebase/database';

const config = {
    projectId: "iimc-slot-booking",
    apiKey: "AIzaSyBpoRRUZo4hTKuIt8nkaBv7lWvMJa6mbm0",
    authDomain: "iimc-slot-booking.firebaseapp.com",
    databaseURL: "https://iimc-slot-booking.firebaseio.com",
}

const Firebase = app.initializeApp(config);

export default Firebase;